module.exports = __webpack_public_path__ + "img/tofu-gehaktburgers.23fb61f2.jpeg";